var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mt-3",attrs:{"color":"primary"},on:{"click":_vm.logInWithFacebook}},[_c('v-icon',[_vm._v("mdi-facebook")]),_vm._v(" Connect Facebook")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }